<script setup lang="tsx">
import type { CondoLocationSectionProps } from '.';

import { useEvents } from '~/composables/events/useEvents';
import { MixpanelProps } from '~/core/service/mixpanel';

import TextLink from '~/components/ui/text-link/TextLink.vue';

import { CondoLocationSection } from '.';

const route = useRoute();
const { trackCtaViewMoreClicked, trackMapPropertyOpened } = useEvents();

const emit = defineEmits<{
	(e: 'cta-clicked'): void;
	(e: 'cta-nearby-properties-clicked'): void;
}>();

const props = defineProps<CondoLocationSectionProps>();

function handleCtaLocationClicked() {
	emit('cta-clicked');
	trackMapPropertyOpened({
		[MixpanelProps.CURRENT_PAGE]: 'Detalhe do Condomínio',
		[MixpanelProps.SECTION_NAME]: 'property location',
		[MixpanelProps.CTA_TEXT]: 'Mapa ampliado',
		[MixpanelProps.CONDO_NAME]: props.condo?.name
	});
}

function handleCtaNearbyPropertiesClicked() {
	emit('cta-nearby-properties-clicked');
	trackCtaViewMoreClicked({
		[MixpanelProps.CURRENT_PAGE]: 'Detalhe do Condomínio',
		[MixpanelProps.CTA_TEXT]: 'Imóveis próximos',
		[MixpanelProps.DESTINATION_URL]: '',
		[MixpanelProps.SECTION_NAME]: 'property location'
	});
}
</script>

<template>
	<section
		v-if="condo"
		id="location"
		ref="locationRef"
		class="w-full py-10 text-primary md:py-12"
	>
		<SectionsLocationSection
			:region="condo.region"
			:city="condo.city"
			:state="condo.state"
			:address="condo.address"
			:number="condo.number"
			:pluscode-group="condo.pluscodeGroup || ''"
			:center-coordinates="{ lat: condo.lat, lng: condo.lng }"
			:is-loading="false"
			:show-quadrilateral="false"
			:show-marker="true"
			:variant="'primary'"
			@cta-clicked="handleCtaLocationClicked"
		>
			<template #another-links>
				<TextLink
					class="flex items-center text-sm"
					variant="dark"
					@click="handleCtaNearbyPropertiesClicked"
				>
					<IconMaterialSymbolsLightVillaOutline class="size-5 text-white" />
					<span class="pl-2 text-sm">Imóveis próximos</span>
				</TextLink>
			</template>
		</SectionsLocationSection>
	</section>
</template>
